import { render, staticRenderFns } from "./DetailGadaiAktif.vue?vue&type=template&id=40067f56&"
import script from "./DetailGadaiAktif.vue?vue&type=script&lang=js&"
export * from "./DetailGadaiAktif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports